// // style
import 'assets/styles/style.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';
import '@/components/tiptap-templates/simple/simple-editor.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

// Redux
import configureStore from './store/configureStore';
import { PersistGate } from 'redux-persist/integration/react';

// Cookie
import { CookiesProvider } from 'react-cookie';

// 시간
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ko } from 'date-fns/locale';

// 라우트
import App from './App';
import { koKR } from '@mui/x-date-pickers/locales';

const { store, persistor } = configureStore()

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko} localeText={koKR.components.MuiLocalizationProvider.defaultProps.localeText}>
              <App />
            </LocalizationProvider>
          </PersistGate>
        </Provider>
      </CookiesProvider>
    </React.StrictMode>
  )
}

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept(App, renderApp)
}

renderApp()

export {store, persistor}